<template>
    <div class="c-row">
        <div class="c-tr">
            <div class="c-tw">
                <div class="c-td">
                    <div class="typo-label">Rozpoczęcie / Zakończenie</div>
                    {{
                        $moment(data.promo.start_at).format('DD-MM-YYYY, HH:mm')
                    }}
                    <br />
                    {{
                        $moment(data.promo.end_at).format(
                            'DD-MM-YYYY, HH:mm'
                        )
                    }}
                </div>
                <div class="c-td">
                    <div class="typo-label">ID / Promocja</div>
                    {{ data.promo.id }} / {{ data.promo.name }}
                </div>
                <div class="c-td">
                    <div class="typo-label">Ogranizator</div>
                    {{ companyName ? companyName.name : '' }}
                </div>
                <div class="c-td">
                    <div class="typo-label">Status</div>
                    {{ statuses[data.promo.status] }}
                </div>
                <div class="c-td">
                    <div class="typo-label">Kwartał/miesiąc</div>
                    <div>
                        <strong>{{ quarters[data.quarter].symbol }} Kwartał ({{
                            data.year
                        }})</strong>
                    </div>
                    <div
                        v-for="(month, idx) in quarters[data.quarter].months"
                        :key="idx"
                    >
                        {{ month }}
                    </div>
                </div>
                <div class="c-td">
                    <div class="typo-label">Spełnienie celu sprzedaży</div>
                    <div>
                        <strong>{{ data.sales }}/{{ data.sales_target }}
                            {{
                                data.sales_target_type === 'hectoliters'
                                    ? 'hl '
                                    : data.sales_target_type
                            }}</strong>
                    </div>
                    <div v-for="(month, idx) in data.months" :key="idx">
                        {{ month.sales }}/{{ month.sales_target }}
                        {{
                            month.sales_target_type === 'hectoliters'
                                ? 'hl '
                                : month.sales_target_type
                        }}
                    </div>
                </div>
                <div class="c-td pl-xl-4">
                    <div class="typo-label">Wykonanie zadania specjalnego</div>
                    <br />
                    <div v-for="(month, idx) in data.months" :key="idx">
                        {{
                            month.special_task === true
                                ? 'Tak'
                                : month.special_task === false
                                    ? 'Nie'
                                    : '-'
                        }}
                    </div>
                </div>
                <div class="c-td pl-xl-2">
                    <div class="typo-label">Wpłacona kwota</div>
                    <br />
                    <div v-for="(month, idx) in data.months" :key="idx">
                        {{ month.refund ? month.refund : '-' }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import statuses from '@/dictionaries/statuses.json'
import quarters from '@/dictionaries/quarters.json'

export default {
    data() {
        return {
            showShops: false,
            statuses,
            quarters
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        companyName() {
            return this.$store.getters.getCompanyById(
                this.data.promo.company_id
            )
        }
    }
}
</script>
